import graphql__06efb4fb65fc07c898d5 from "./__generated__/SeparateSupplierSpellingDialogMutation.graphql.ts";import * as React from "react";
import {graphql} from "react-relay";
import {useRelayEnvironment} from "react-relay/hooks";
import {useIntl} from "react-intl";
import FormDialog from "./FormDialog";
import Section from "../form/Section";
import {commitMutationWithErrorHandling} from "../../helper/commitMutationWithErrorHandling";
import {useErrorContext} from "../../contexts/ErrorContext";
import type {SeparateSupplierSpellingDialogMutation} from "./__generated__/SeparateSupplierSpellingDialogMutation.graphql";

type Props = {
    supplier: {
        name: string
    }
    spelling: string
    onClose: (changed: boolean) => void
}

const SeparateSupplierSpellingDialog: React.FC<Props> = ({supplier, spelling, onClose}) => {
    const intl = useIntl();
    const relayEnvironment = useRelayEnvironment();
    const {addError} = useErrorContext();

    const handleSubmission = () => {
        commitMutationWithErrorHandling<SeparateSupplierSpellingDialogMutation>(
            relayEnvironment,
            {
                mutation: graphql__06efb4fb65fc07c898d5,
                variables: {input: {spelling}},
                onCompleted: () => onClose(true),
                onError: () => onClose(false),
            },
            addError,
            {customErrorMessage: intl.formatMessage({id: 'errors.failedToSeparateSupplierSpelling'})}
        );
    };

    return (
        <FormDialog handleCloseDialog={() => onClose(false)}
                    handleSubmission={handleSubmission}
                    initialValues={{}}
                    headline={intl.formatMessage({id: 'dialog.SeparateSupplierSpellingDialog.headline'})}
                    submitLabel={intl.formatMessage({id: 'dialog.SeparateSupplierSpellingDialog.submit'})}>
            <Section>
                <p className="text-sm text-gray-700 whitespace-pre-wrap">
                    {intl.formatMessage({id: 'dialog.SeparateSupplierSpellingDialog.description'}, {spelling, name: supplier.name})}
                </p>
            </Section>
        </FormDialog>
    );
};

export default SeparateSupplierSpellingDialog;
